module.exports = "/_next/static/images/gb-eng-2d5bac56a4ce420c040d5fa963855cdb.svg";